import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { LegalDocumentService } from '../../service/LegalDocumentService';

const legalDocumentService = new LegalDocumentService();

const initialState = {
  documentList: [],
  status: 'idle',
  error: null,
};

export const getLegalDocumentsAsync = createAsyncThunk(
  'legalDocuments/list',
  async ({ type }, { rejectWithValue }) => {
    try {
      return await legalDocumentService.getDocuments(type);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao buscar documentos legais');
    }
  }
);

export const createLegalDocumentDraftAsync = createAsyncThunk(
  'legalDocuments/createDraft',
  async ({ type, content }, { rejectWithValue }) => {
    try {
      await legalDocumentService.createDraft(type, content);
      return await legalDocumentService.getDocuments(type);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao criar rascunho');
    }
  }
);

export const deleteLegalDocumentDraftAsync = createAsyncThunk(
  'legalDocuments/deleteDraft',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      await legalDocumentService.deleteDraft(id);
      return await legalDocumentService.getDocuments(type);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao excluir rascunho');
    }
  }
);

export const publishLegalDocumentAsync = createAsyncThunk(
  'legalDocuments/publish',
  async ({ id, type }, { rejectWithValue }) => {
    try {
      await legalDocumentService.publish(id);
      return await legalDocumentService.getDocuments(type);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erro ao publicar documento');
    }
  }
);

export const legalDocumentsSlice = createSlice({
  name: 'legalDocumentsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLegalDocumentsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getLegalDocumentsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.documentList = action.payload;
      })
      .addCase(getLegalDocumentsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(createLegalDocumentDraftAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(createLegalDocumentDraftAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.documentList = action.payload;
      })
      .addCase(createLegalDocumentDraftAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(deleteLegalDocumentDraftAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(deleteLegalDocumentDraftAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.documentList = action.payload;
      })
      .addCase(deleteLegalDocumentDraftAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(publishLegalDocumentAsync.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(publishLegalDocumentAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.documentList = action.payload;
      })
      .addCase(publishLegalDocumentAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const selectLegalDocumentList = (state) => state.legalDocuments.documentList;
export const selectLoading = (state) => state.legalDocuments.status === 'loading';
export const selectError = (state) => state.legalDocuments.error;

export default legalDocumentsSlice.reducer;
